import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    id: 1,
    title: 'Los 30 Ganchos (Hooks) Virales',
    value: '$19',
    image: 'https://cdn.magicpatterns.com/uploads/dXvBWpuZpF14DAb2XJMRpu/Bono1.png',
    desc: 'Frases exactas para detener el scroll y atraer prospectos en Reels e Historias.'
  }, {
    id: 2,
    title: 'Plantillas de Canva para Post de Reclutamiento',
    value: '$27',
    image: 'https://cdn.magicpatterns.com/uploads/hdHHHXk68teKBe2kVoFNs1/Bono2.png',
    desc: 'Diseños listos para publicar (Reels, Carruseles y Stories) sin perder horas diseñando.'
  }, {
    id: 3,
    title: 'Guía Anti-Objeciones (El Escudo del Networker)',
    value: '$25',
    image: 'https://cdn.magicpatterns.com/uploads/btnPPX2L2Tpp1ov6L8vmH2/Bono3.png',
    desc: "Qué responder exactamente cuando te dicen: '¿Es pirámide?' o 'No tengo dinero'."
  }];
  return <section className="bg-brand-dark px-6 py-20 md:py-28 border-y border-slate-800" data-id="element-14">
      <div className="mx-auto max-w-6xl" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <div className="inline-flex items-center justify-center p-3 bg-green-500/10 rounded-full mb-4" data-id="element-17">
            <Gift className="w-8 h-8 text-green-500" data-id="element-18" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-19">
            Bonos de Acción Rápida
          </h2>
          <p className="text-xl text-slate-400" data-id="element-20">
            Llévate estos 3 regalos exclusivos completamente{' '}
            <span className="text-green-400 font-bold uppercase" data-id="element-21">Gratis</span>{' '}
            al unirte hoy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-22">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-brand-light rounded-2xl overflow-hidden border border-slate-800 flex flex-col" data-id="element-23">
              <div className="bg-brand-darker p-4 text-center border-b border-slate-800" data-id="element-24">
                <span className="text-brand-gold font-bold uppercase tracking-wider text-sm" data-id="element-25">
                  Bono #{bonus.id}
                </span>
              </div>

              <div className="aspect-square relative p-6 bg-gradient-to-b from-brand-light to-brand-darker flex items-center justify-center" data-id="element-26">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain drop-shadow-2xl" data-id="element-27" />
              </div>

              <div className="p-6 flex-1 flex flex-col" data-id="element-28">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-29">
                  {bonus.title}
                </h3>
                <p className="text-slate-400 text-sm mb-6 flex-1" data-id="element-30">
                  {bonus.desc}
                </p>
                <div className="mt-auto pt-4 border-t border-slate-800 flex justify-between items-center" data-id="element-31">
                  <span className="text-slate-500 line-through" data-id="element-32">
                    Valor: {bonus.value}
                  </span>
                  <span className="text-green-400 font-bold" data-id="element-33">¡GRATIS HOY!</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}